import {
    useMemo,
} from 'react'
import IconButton from '@mui/material/IconButton'
import useRatesRoutes from 'app/SkyNetRoutes/hooks/useRatesRoutes'
import {
    ReactComponent as BulkEditSvg,
} from 'app/shared-components/images/icons/bulk_edit.svg'
import SkyNetDataGrid from 'app/shared-components/SkyNetDataGrid'
import useDataGridSource from 'app/shared-components/SkyNetMasterDataGrid/hooks/useDataGridSource'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import useLabel from 'app/hooks/useLabel'
import requests from 'app/requests/APricingRateCard/APricingRateCard.requests'
import {
    PersistentKeys,
    registerPersistentKey,
} from 'app/enums/persistentKeys'
import {
    APricingRateCardResponse,
} from 'app/requests/APricingRateCard/APricingRateCard.types'
import {
    RateCardStatus,
} from 'app/enums/label.enums'

import getColumns from './StandardBaseLease.columns'
import useStyles from './StandardBaseLease.styles'

const persistentKey = registerPersistentKey(PersistentKeys.ARateCardsBaseLeaseTable)

const StandardBaseLease = ({
    data,
}: Readonly<{ data: APricingRateCardResponse }>) => {
    const l = useLabel()
    const {
        ARateCards: ARateCardsRoutes,
    } = useRatesRoutes()
    const {
        classes,
    } = useStyles()

    const isEditable = data?.status === RateCardStatus.IN_PROGRESS

    const dataSource = useDataGridSource({
        request: requests.standardBaseLeaseFilterRequest({
            rateCardId: data?.id,
        }),
        key: RequestKeys.getAPricingRateCardBaseLeaseFilterRequest,
    })

    const columns = useMemo(() => {
        return getColumns({
            classes,
        })
    }, [classes])

    const toolbarControls = useMemo(() => {
        if (!isEditable) {
            return []
        }
        return [(
            <IconButton
                data-testid="bulk-edit-btn"
                onClick={() => {
                    ARateCardsRoutes.BulkEdit.BaseLease.navigate({
                        params: {
                            key: data.id,
                        },
                    })
                }}
            >
                <BulkEditSvg />
            </IconButton>
        )]
    }, [
        ARateCardsRoutes.BulkEdit.BaseLease,
        data.id,
        isEditable,
    ])

    return (
        <SkyNetDataGrid
            persistentKey={persistentKey}
            customDataSource={dataSource}
            columns={columns}
            toolbarProps={{
                title: l('STANDARD_BASE_LEASE'),
                toolbarControls,
            }}
        />
    )
}

export default StandardBaseLease
